import type { EsgSfdrTaxonomy } from 'src/tpbp-core/models/esg/esg.types'
import type { EsgPaiApi } from 'src/tpbp-json-api-handler/esg/esg.api.types'

export type InvestorProfileIncludedApi = {
  attributes: {
    kind: string
    esg_criteria: {
      esg_pai: EsgPaiApi
      esg_sfdr: EsgSfdrTaxonomy
      esg_taxonomy: EsgSfdrTaxonomy
    }
  }
}

export const InvestorProfileApiLabels = {
  SECURE: 'Sécuritaire',
  CAUTIOUS: 'Prudent',
  BALANCED: 'Équilibré',
  DYNAMIC: 'Dynamique',
  AGGRESSIVE: 'Offensif',
  NONE: '',
} as const
type InvestorProfileApiLabels = typeof InvestorProfileApiLabels

export type InvestorProfileApiLabel = ValueOf<InvestorProfileApiLabels>

export const MinorInvestorProfileApiScores = {
  NONE: -1,
  SECURE: 1,
  CAUTIOUS: 2,
} as const

export type MinorInvestorProfileApiScore = ValueOf<
  typeof MinorInvestorProfileApiScores
>

export type InvestorProfileApi = {
  attributes: {
    label: string
    score: number | undefined
    updated_at: string | undefined

    pi_score: number | undefined
    pi_label: string | undefined
    qce_code: string | undefined
    qce_label: string | undefined
    esg_score: number | undefined
    esg_label: string | undefined

    is_updatable: boolean
    requires_update: boolean
    pi_is_updatable: boolean
    pi_requires_update: boolean
    qce_is_updatable: boolean
    qce_requires_update: boolean
    esg_is_updatable: boolean
    esg_requires_update: boolean

    risk_interval?: {
      min: number
      max: number
      target: number
    }
  }
}

export type InvestorProfileApiResponse = {
  data: InvestorProfileApi
  included?: InvestorProfileIncludedApi[]
}
